import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService } from './auth.service';

@Injectable()
export class BaseService {

    apiUrl: string;

    constructor(private http: HttpClient, private router: Router, private authService: AuthService) {
        this.apiUrl = authService.getApiIP();
    }

    getToken(params){
        params = params.append('login_token', localStorage.getItem('loginToken') ? localStorage.getItem('loginToken') : '');
        //adicionado a origem para podermos limitar o acesso por tipo de usuário
        params = params.append('origin', 'easy-check-web');

        // adicionado para tornar o link do agendamento dinâmico
        const headers = new HttpHeaders({
            'x-origin': window.location.host,
        });

        return { params, headers };
    }

    catchError(err: any = {}) {
        let message = err.message || err.error && err.error.message;

        if(err.status === 401){
            if(!this.authService.existParams()) {
                this.authService.setLogoutState();
                this.router.navigate(['/login']);
            }
        } else if(err.status == 403) {
            console.warn('invalid_access_rule', message);
            err = { message: 'invalid_access_rule' };
        } else if(!err.status) {
            console.warn('connection_refused', message);
            err = { message: 'connection_refused' };
        } else if (err.status == 200) {
            console.warn('isnt_an_error');
            return Promise.resolve();
        }

        return Observable.throw(err);
    }

    get (path: string, endpoint: string, incomingParams?: any) {

        let params = new HttpParams();

        /**
         * Note: incomingParams[x] === 0 is necessary because of dataTable lazy loading, which returns a zero when
         * in first page.
         * */

        if (incomingParams) {
            for (const x in incomingParams) {
                if (incomingParams[x] || incomingParams[x] === 0) params = params.append(x, incomingParams[x]);
            }
        }

        console.log('Get: ', this.apiUrl + path + endpoint);
        return this.http.get(this.apiUrl + path + endpoint, this.getToken(params)).catch((err) => this.catchError(err));
    }
    getFile (path: string, endpoint: string, incomingParams?: any) {
        let params = new HttpParams();
        // params.set('Headers', '"Content-Type":" "blob""')
        /**
         * Note: incomingParams[x] === 0 is necessary because of dataTable lazy loading, which returns a zero when
         * in first page.
         * */
        //  const headers = new HttpHeaders({'Content-Type':'blob; charset=utf-8'});

        if (incomingParams) {
            for (const x in incomingParams) {
                if (incomingParams[x] || incomingParams[x] === 0) params = params.append(x, incomingParams[x]);
            }
        }

        console.log('Get: ', this.apiUrl + path + endpoint);
        return this.http.get(this.apiUrl + path + endpoint, {responseType:'arraybuffer',...this.getToken(params)}).catch((err) => this.catchError(err));
    }
    post(path: string, endpoint: string, object: any) {
        let params = new HttpParams();
        console.log('Post: ', this.apiUrl + path + endpoint);
        console.log('Using: ', object);
        return this.http.post(this.apiUrl + path + endpoint, object, this.getToken(params)).catch((err) => this.catchError(err));
    }

    postWithParams(path: string, endpoint: string, object: any, incomingParams?: any) {
        let params = new HttpParams();
        console.log('Post: ', this.apiUrl + path + endpoint);
        console.log('Using: ', object);

        if (incomingParams) {
            for (const x in incomingParams) {
                if (incomingParams[x] || incomingParams[x] === 0) params = params.append(x, incomingParams[x]);
            }
        }
        
        return this.http.post(this.apiUrl + path + endpoint, object, this.getToken(params)).catch((err) => this.catchError(err));
    }

    put(path: string, endpoint: string, object?: any) {
        let params = new HttpParams();
        console.log('Put: ', this.apiUrl + path + endpoint);
        console.log('Using: ', object);
        return this.http.put(this.apiUrl + path + endpoint, object, this.getToken(params)).catch((err) => this.catchError(err));
    }

    delete(path: string, endpoint: string) {
        let params = new HttpParams();
        console.log('Delete: ', this.apiUrl + path + endpoint);
        return this.http.delete(this.apiUrl + path + endpoint, this.getToken(params)).catch((err) => this.catchError(err));
    }

    getWithProxy (path: string, endpoint: string, options: any) {
        return this.http.get(path + endpoint, options).catch((err) => this.catchError(err));
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/base.service.ts